module.exports = __webpack_public_path__ + "img/payment08.139cda2f.png";